"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserOnStage = void 0;
var OnStageStatus = {
  DEFAULT: 'DEFAULT',
  ON_STAGE: 'ON_STAGE',
  INVITED: 'INVITED',
  REJECTED: 'REJECTED'
};

var isUserOnStage = function isUserOnStage(onStageStatus) {
  return onStageStatus !== OnStageStatus.DEFAULT;
};

exports.isUserOnStage = isUserOnStage;